import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import ServicesMarquee from "@/components/landing/ServicesMarquee";
import Services from "@/components/landing/Services";
import Problems from "@/components/landing/Problems";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import Pricing from "@/components/landing/Pricing";
import Coverage from "@/components/landing/Coverage";
import Process from "@/components/landing/Process";
import Gallery from "@/components/landing/Gallery";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import MobileBottomNav from "@/components/landing/MobileBottomNav";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-void text-ink antialiased overflow-x-clip selection:bg-brand selection:text-black">
      <a
        href="#layanan"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:bg-brand focus:text-black focus:px-4 focus:py-2 focus:font-bold"
      >
        Langsung ke konten
      </a>
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <ServicesMarquee />
        <Services />
        <Problems />
        <WhyChooseUs />
        <Pricing />
        <Coverage />
        <Process />
        <Gallery />
        <Testimonials />
        <Faq />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
      <MobileBottomNav />
    </div>
  );
}
